/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as SignUpRouteImport } from "./routes/sign-up"
import { Route as SignInRouteImport } from "./routes/sign-in"
import { Route as ForbiddenRouteImport } from "./routes/forbidden"
import { Route as DashboardRouteImport } from "./routes/dashboard"
import { Route as SettingsRouteRouteImport } from "./routes/settings/route"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as TargetsIndexRouteImport } from "./routes/targets/index"
import { Route as SettingsIndexRouteImport } from "./routes/settings/index"
import { Route as TargetsNewRouteImport } from "./routes/targets/new"
import { Route as SettingsUsageRouteImport } from "./routes/settings/usage"
import { Route as SettingsOrganizationRouteImport } from "./routes/settings/organization"
import { Route as SettingsMembersRouteImport } from "./routes/settings/members"
import { Route as SettingsBillingRouteImport } from "./routes/settings/billing"
import { Route as SettingsAuditRouteImport } from "./routes/settings/audit"
import { Route as CliAuthRouteImport } from "./routes/cli/auth"
import { Route as TargetsTargetIdIndexRouteImport } from "./routes/targets/$targetId/index"
import { Route as PublicScansScanDisplayIdRouteImport } from "./routes/public/scans/$scanDisplayId"
import { Route as TargetsTargetIdScansScanIdRouteImport } from "./routes/targets/$targetId/scans/$scanId"
import { Route as TargetsTargetIdIssuesIssueIdRouteImport } from "./routes/targets/$targetId/issues/$issueId"

const SignUpRoute = SignUpRouteImport.update({
  id: "/sign-up",
  path: "/sign-up",
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => rootRouteImport,
} as any)
const ForbiddenRoute = ForbiddenRouteImport.update({
  id: "/forbidden",
  path: "/forbidden",
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const TargetsIndexRoute = TargetsIndexRouteImport.update({
  id: "/targets/",
  path: "/targets/",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const TargetsNewRoute = TargetsNewRouteImport.update({
  id: "/targets/new",
  path: "/targets/new",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsUsageRoute = SettingsUsageRouteImport.update({
  id: "/usage",
  path: "/usage",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsOrganizationRoute = SettingsOrganizationRouteImport.update({
  id: "/organization",
  path: "/organization",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsMembersRoute = SettingsMembersRouteImport.update({
  id: "/members",
  path: "/members",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsBillingRoute = SettingsBillingRouteImport.update({
  id: "/billing",
  path: "/billing",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsAuditRoute = SettingsAuditRouteImport.update({
  id: "/audit",
  path: "/audit",
  getParentRoute: () => SettingsRouteRoute,
} as any)
const CliAuthRoute = CliAuthRouteImport.update({
  id: "/cli/auth",
  path: "/cli/auth",
  getParentRoute: () => rootRouteImport,
} as any)
const TargetsTargetIdIndexRoute = TargetsTargetIdIndexRouteImport.update({
  id: "/targets/$targetId/",
  path: "/targets/$targetId/",
  getParentRoute: () => rootRouteImport,
} as any)
const PublicScansScanDisplayIdRoute =
  PublicScansScanDisplayIdRouteImport.update({
    id: "/public/scans/$scanDisplayId",
    path: "/public/scans/$scanDisplayId",
    getParentRoute: () => rootRouteImport,
  } as any)
const TargetsTargetIdScansScanIdRoute =
  TargetsTargetIdScansScanIdRouteImport.update({
    id: "/targets/$targetId/scans/$scanId",
    path: "/targets/$targetId/scans/$scanId",
    getParentRoute: () => rootRouteImport,
  } as any)
const TargetsTargetIdIssuesIssueIdRoute =
  TargetsTargetIdIssuesIssueIdRouteImport.update({
    id: "/targets/$targetId/issues/$issueId",
    path: "/targets/$targetId/issues/$issueId",
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/settings": typeof SettingsRouteRouteWithChildren
  "/dashboard": typeof DashboardRoute
  "/forbidden": typeof ForbiddenRoute
  "/sign-in": typeof SignInRoute
  "/sign-up": typeof SignUpRoute
  "/cli/auth": typeof CliAuthRoute
  "/settings/audit": typeof SettingsAuditRoute
  "/settings/billing": typeof SettingsBillingRoute
  "/settings/members": typeof SettingsMembersRoute
  "/settings/organization": typeof SettingsOrganizationRoute
  "/settings/usage": typeof SettingsUsageRoute
  "/targets/new": typeof TargetsNewRoute
  "/settings/": typeof SettingsIndexRoute
  "/targets/": typeof TargetsIndexRoute
  "/public/scans/$scanDisplayId": typeof PublicScansScanDisplayIdRoute
  "/targets/$targetId/": typeof TargetsTargetIdIndexRoute
  "/targets/$targetId/issues/$issueId": typeof TargetsTargetIdIssuesIssueIdRoute
  "/targets/$targetId/scans/$scanId": typeof TargetsTargetIdScansScanIdRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/dashboard": typeof DashboardRoute
  "/forbidden": typeof ForbiddenRoute
  "/sign-in": typeof SignInRoute
  "/sign-up": typeof SignUpRoute
  "/cli/auth": typeof CliAuthRoute
  "/settings/audit": typeof SettingsAuditRoute
  "/settings/billing": typeof SettingsBillingRoute
  "/settings/members": typeof SettingsMembersRoute
  "/settings/organization": typeof SettingsOrganizationRoute
  "/settings/usage": typeof SettingsUsageRoute
  "/targets/new": typeof TargetsNewRoute
  "/settings": typeof SettingsIndexRoute
  "/targets": typeof TargetsIndexRoute
  "/public/scans/$scanDisplayId": typeof PublicScansScanDisplayIdRoute
  "/targets/$targetId": typeof TargetsTargetIdIndexRoute
  "/targets/$targetId/issues/$issueId": typeof TargetsTargetIdIssuesIssueIdRoute
  "/targets/$targetId/scans/$scanId": typeof TargetsTargetIdScansScanIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/settings": typeof SettingsRouteRouteWithChildren
  "/dashboard": typeof DashboardRoute
  "/forbidden": typeof ForbiddenRoute
  "/sign-in": typeof SignInRoute
  "/sign-up": typeof SignUpRoute
  "/cli/auth": typeof CliAuthRoute
  "/settings/audit": typeof SettingsAuditRoute
  "/settings/billing": typeof SettingsBillingRoute
  "/settings/members": typeof SettingsMembersRoute
  "/settings/organization": typeof SettingsOrganizationRoute
  "/settings/usage": typeof SettingsUsageRoute
  "/targets/new": typeof TargetsNewRoute
  "/settings/": typeof SettingsIndexRoute
  "/targets/": typeof TargetsIndexRoute
  "/public/scans/$scanDisplayId": typeof PublicScansScanDisplayIdRoute
  "/targets/$targetId/": typeof TargetsTargetIdIndexRoute
  "/targets/$targetId/issues/$issueId": typeof TargetsTargetIdIssuesIssueIdRoute
  "/targets/$targetId/scans/$scanId": typeof TargetsTargetIdScansScanIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/settings"
    | "/dashboard"
    | "/forbidden"
    | "/sign-in"
    | "/sign-up"
    | "/cli/auth"
    | "/settings/audit"
    | "/settings/billing"
    | "/settings/members"
    | "/settings/organization"
    | "/settings/usage"
    | "/targets/new"
    | "/settings/"
    | "/targets/"
    | "/public/scans/$scanDisplayId"
    | "/targets/$targetId/"
    | "/targets/$targetId/issues/$issueId"
    | "/targets/$targetId/scans/$scanId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/dashboard"
    | "/forbidden"
    | "/sign-in"
    | "/sign-up"
    | "/cli/auth"
    | "/settings/audit"
    | "/settings/billing"
    | "/settings/members"
    | "/settings/organization"
    | "/settings/usage"
    | "/targets/new"
    | "/settings"
    | "/targets"
    | "/public/scans/$scanDisplayId"
    | "/targets/$targetId"
    | "/targets/$targetId/issues/$issueId"
    | "/targets/$targetId/scans/$scanId"
  id:
    | "__root__"
    | "/"
    | "/settings"
    | "/dashboard"
    | "/forbidden"
    | "/sign-in"
    | "/sign-up"
    | "/cli/auth"
    | "/settings/audit"
    | "/settings/billing"
    | "/settings/members"
    | "/settings/organization"
    | "/settings/usage"
    | "/targets/new"
    | "/settings/"
    | "/targets/"
    | "/public/scans/$scanDisplayId"
    | "/targets/$targetId/"
    | "/targets/$targetId/issues/$issueId"
    | "/targets/$targetId/scans/$scanId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  DashboardRoute: typeof DashboardRoute
  ForbiddenRoute: typeof ForbiddenRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  CliAuthRoute: typeof CliAuthRoute
  TargetsNewRoute: typeof TargetsNewRoute
  TargetsIndexRoute: typeof TargetsIndexRoute
  PublicScansScanDisplayIdRoute: typeof PublicScansScanDisplayIdRoute
  TargetsTargetIdIndexRoute: typeof TargetsTargetIdIndexRoute
  TargetsTargetIdIssuesIssueIdRoute: typeof TargetsTargetIdIssuesIssueIdRoute
  TargetsTargetIdScansScanIdRoute: typeof TargetsTargetIdScansScanIdRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/sign-up": {
      id: "/sign-up"
      path: "/sign-up"
      fullPath: "/sign-up"
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/sign-in": {
      id: "/sign-in"
      path: "/sign-in"
      fullPath: "/sign-in"
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/forbidden": {
      id: "/forbidden"
      path: "/forbidden"
      fullPath: "/forbidden"
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dashboard": {
      id: "/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings": {
      id: "/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/targets/": {
      id: "/targets/"
      path: "/targets"
      fullPath: "/targets/"
      preLoaderRoute: typeof TargetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings/": {
      id: "/settings/"
      path: "/"
      fullPath: "/settings/"
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/targets/new": {
      id: "/targets/new"
      path: "/targets/new"
      fullPath: "/targets/new"
      preLoaderRoute: typeof TargetsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings/usage": {
      id: "/settings/usage"
      path: "/usage"
      fullPath: "/settings/usage"
      preLoaderRoute: typeof SettingsUsageRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/organization": {
      id: "/settings/organization"
      path: "/organization"
      fullPath: "/settings/organization"
      preLoaderRoute: typeof SettingsOrganizationRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/members": {
      id: "/settings/members"
      path: "/members"
      fullPath: "/settings/members"
      preLoaderRoute: typeof SettingsMembersRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/billing": {
      id: "/settings/billing"
      path: "/billing"
      fullPath: "/settings/billing"
      preLoaderRoute: typeof SettingsBillingRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/settings/audit": {
      id: "/settings/audit"
      path: "/audit"
      fullPath: "/settings/audit"
      preLoaderRoute: typeof SettingsAuditRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    "/cli/auth": {
      id: "/cli/auth"
      path: "/cli/auth"
      fullPath: "/cli/auth"
      preLoaderRoute: typeof CliAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/targets/$targetId/": {
      id: "/targets/$targetId/"
      path: "/targets/$targetId"
      fullPath: "/targets/$targetId/"
      preLoaderRoute: typeof TargetsTargetIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/public/scans/$scanDisplayId": {
      id: "/public/scans/$scanDisplayId"
      path: "/public/scans/$scanDisplayId"
      fullPath: "/public/scans/$scanDisplayId"
      preLoaderRoute: typeof PublicScansScanDisplayIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/targets/$targetId/scans/$scanId": {
      id: "/targets/$targetId/scans/$scanId"
      path: "/targets/$targetId/scans/$scanId"
      fullPath: "/targets/$targetId/scans/$scanId"
      preLoaderRoute: typeof TargetsTargetIdScansScanIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/targets/$targetId/issues/$issueId": {
      id: "/targets/$targetId/issues/$issueId"
      path: "/targets/$targetId/issues/$issueId"
      fullPath: "/targets/$targetId/issues/$issueId"
      preLoaderRoute: typeof TargetsTargetIdIssuesIssueIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SettingsRouteRouteChildren {
  SettingsAuditRoute: typeof SettingsAuditRoute
  SettingsBillingRoute: typeof SettingsBillingRoute
  SettingsMembersRoute: typeof SettingsMembersRoute
  SettingsOrganizationRoute: typeof SettingsOrganizationRoute
  SettingsUsageRoute: typeof SettingsUsageRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsAuditRoute: SettingsAuditRoute,
  SettingsBillingRoute: SettingsBillingRoute,
  SettingsMembersRoute: SettingsMembersRoute,
  SettingsOrganizationRoute: SettingsOrganizationRoute,
  SettingsUsageRoute: SettingsUsageRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  DashboardRoute: DashboardRoute,
  ForbiddenRoute: ForbiddenRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  CliAuthRoute: CliAuthRoute,
  TargetsNewRoute: TargetsNewRoute,
  TargetsIndexRoute: TargetsIndexRoute,
  PublicScansScanDisplayIdRoute: PublicScansScanDisplayIdRoute,
  TargetsTargetIdIndexRoute: TargetsTargetIdIndexRoute,
  TargetsTargetIdIssuesIssueIdRoute: TargetsTargetIdIssuesIssueIdRoute,
  TargetsTargetIdScansScanIdRoute: TargetsTargetIdScansScanIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
